import React from 'react';

const Renew = () => (<div />);

export default Renew;
